// extracted by mini-css-extract-plugin
export default {"root":"LibraryFileCard_root__-Gy6l","container":"LibraryFileCard_container__XuRvt","clickable":"LibraryFileCard_clickable__turP7"};